import { Site } from '../../sites/models/site.model';

/**
 * Hook that returns whether or not a given site is eligible for trial v2.
 *
 * As of writing this, the rules are that the account has to be eligible for trial v2 (see
 * `useAccountTrialV2Eligibility`) and the site has to have its tracking code installed.
 *
 * @param isAccountTrialV2Eligible Result of the `useAccountTrialV2Eligibility` hook
 * @param site Site object
 * @returns Whether the site is eligible for trial v2
 */
export const useSiteTrialV2Eligibility = (
  isAccountTrialV2Eligible: boolean,
  site: Pick<Site, 'last_data_time'> | undefined
): boolean => {
  return isAccountTrialV2Eligible && !!site?.last_data_time;
};
